import { ITEM_TYPES } from '../../types/ItemTypes';
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
import { sanitizeUrl } from '../../utils/sanitize-url';
import { get } from '../../utils/get';
import { getMainImageUrl } from './calculated/program/get-main-image-url';
import { getRobots } from './calculated/program/get-robots';
import { shorten } from '../../utils/shorten';
import { getName } from './calculated/program/get-name';
import { getCreatedDate } from './calculated/program/get-created-date';
import { getCurrency } from './calculated/program/get-currency';
import { getPrice } from './calculated/program/get-price';
import { trimTrailingSlash } from '../../utils/trim-trailing-slash';
import { SD_STATUS } from '../../consts';
import { getItemsSdStatus } from '../utils';
import { getBasicVideosObject } from '../../adapters/get-basic-videos-object';
export var getData = function (IDs, itemData) {
    var _a;
    var imageId = get(itemData, 'program.settings.description.media.image.id');
    var fullDescription = get(itemData, 'program.settings.description.details');
    var baseUrl = trimTrailingSlash(get(itemData, 'program.settings.seo.url.base'));
    var path = get(itemData, 'program.settings.seo.url.path');
    var width = get(itemData, 'program.settings.description.media.image.width');
    var height = get(itemData, 'program.settings.description.media.image.height');
    var imageWidth = width !== '0' && width !== '' ? width : '800';
    var imageHeight = height !== '0' && height !== '' ? height : '600';
    var createdDate = getCreatedDate(itemData);
    var programName = get(itemData, 'program.settings.description.title');
    var hasVideo = get(itemData, 'program.settings.description.media.video');
    var videoUrl = get(itemData, 'program.settings.description.media.video.url');
    var videosData = hasVideo
        ? [
            {
                name: programName,
                thumbnailUrl: get(itemData, 'program.settings.description.media.video.thumbnail.url'),
                uploadDate: createdDate,
                contentUrl: videoUrl ? 'https://video.wixstatic.com/' + videoUrl : '',
            },
        ]
        : [];
    var validVideos = getBasicVideosObject(videosData.filter(function (video) { return video.name && video.thumbnailUrl && video.uploadDate; }), {
        includeContext: false,
        positioning: false,
    }).videos || '';
    var videosSdStatus = getItemsSdStatus(videosData, validVideos);
    return _a = {},
        _a[IDs.ID] = get(itemData, 'program.id'),
        _a[IDs.AVAILABILITY] = get(itemData, 'program.settings.accessRestrictions.accessType'),
        _a[IDs.MAIN_IMAGE] = getMainImageUrl(itemData, imageWidth, imageHeight),
        _a[IDs.CALCULATED_ROBOTS] = getRobots(itemData),
        _a[IDs.CREATED_DATE] = createdDate,
        _a[IDs.CURRENCY] = getCurrency(itemData),
        _a[IDs.DESCRIPTION] = fullDescription,
        _a[IDs.DESCRIPTION_150] = shorten(fullDescription, 150),
        _a[IDs.IMAGE_HEIGHT] = imageId ? imageHeight : '',
        _a[IDs.IMAGE_ID] = imageId,
        _a[IDs.IMAGE_WIDTH] = imageId ? imageWidth : '',
        _a[IDs.IMAGE_ALT] = get(itemData, 'program.settings.description.media.image.altText'),
        _a[IDs.TITLE] = programName,
        _a[IDs.CALCULATED_NAME] = getName(itemData),
        _a[IDs.PRICE] = getPrice(itemData),
        _a[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.CHALLENGES_PAGE, itemData, sanitizeUrl("".concat(baseUrl).concat(path))),
        _a[IDs.SD_JSON_VIDEOS] = validVideos,
        _a[IDs.DISABLE_VIDEOS_SCHEMA] = videosSdStatus !== SD_STATUS.ENABLED,
        _a[IDs.VIDEOS_SD_STATUS] = videosSdStatus,
        _a;
};
